export default function Loading() {
  return (
    <div id="preloader">
      <svg
        width="91"
        height="91"
        viewBox="0 0 91 91"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="45.5"
          cy="45.5"
          r="45"
          fill="#090E17"
          stroke="url(#paint0_linear_173_52)"
        />
        <path
          id="one"
          d="M49.1061 39.8365L45.6803 37.6396C47.6135 36.5132 48.9578 35.7078 49.8827 34.9944C50.8454 34.2518 51.3693 33.5974 51.6316 32.7677C51.8903 31.949 51.8885 30.9739 51.841 29.6112C51.8337 29.4026 51.8254 29.1845 51.8166 28.9559C51.7698 27.7374 51.7115 26.2212 51.749 24.2643L55.4058 26.5033C55.3824 27.9016 55.4031 29.0822 55.4208 30.0918C55.4301 30.6232 55.4386 31.1072 55.4393 31.5507C55.4416 32.8618 55.3767 33.8219 55.0809 34.6544C54.7871 35.4814 54.2603 36.1956 53.3122 37.0005C52.3738 37.7971 51.0304 38.676 49.1061 39.8365Z"
          fill="#A747ED"
          stroke="#A747ED"
          strokeWidth="0.3"
          strokeMiterlimit="2.61313"
        />
        <path
          id="two"
          d="M55.6152 43.9488L52.1893 41.7519C54.1225 40.6254 55.4668 39.82 56.3917 39.1066C57.3544 38.3641 57.8784 37.7096 58.1406 36.8799C58.3994 36.0612 58.3975 35.0861 58.3501 33.7235C58.3428 33.5149 58.3344 33.2967 58.3256 33.0681C58.2788 31.8497 58.2205 30.3334 58.258 28.3766L61.9149 30.6156C61.8914 32.0139 61.9121 33.1944 61.9298 34.204C61.9391 34.7354 61.9476 35.2195 61.9484 35.663C61.9507 36.974 61.8857 37.9341 61.5899 38.7667C61.2961 39.5936 60.7693 40.3079 59.8212 41.1127C58.8828 41.9093 57.5395 42.7882 55.6152 43.9488Z"
          fill="#A747ED"
          stroke="#A747ED"
          strokeWidth="0.3"
          strokeMiterlimit="2.61313"
        />
        <path
          id="three"
          d="M34.6777 30.0918C34.6954 29.0822 34.716 27.9016 34.6926 26.5033L38.3494 24.2643C38.3869 26.2212 38.3287 27.7374 38.2818 28.9559C38.2731 29.1845 38.2647 29.4026 38.2574 29.6112C38.2099 30.9739 38.2081 31.949 38.4669 32.7677C38.7291 33.5974 39.253 34.2518 40.2158 34.9944C41.1407 35.7078 42.4849 36.5132 44.4181 37.6396L40.9923 39.8365C39.068 38.676 37.7247 37.7971 36.7863 37.0005C35.8381 36.1956 35.3114 35.4814 35.0176 34.6544C34.7217 33.8219 34.6568 32.8618 34.6591 31.5507C34.6599 31.1072 34.6684 30.6232 34.6777 30.0918Z"
          fill="#A747ED"
          stroke="#A747ED"
          strokeWidth="0.3"
          strokeMiterlimit="2.61313"
        />
        <path
          id="four"
          d="M28.1686 34.204C28.1863 33.1944 28.207 32.0139 28.1835 30.6156L31.8404 28.3766C31.8779 30.3334 31.8196 31.8496 31.7728 33.0681C31.764 33.2967 31.7557 33.5149 31.7484 33.7235C31.7009 35.0861 31.6991 36.0612 31.9578 36.8799C32.2201 37.7096 32.744 38.3641 33.7067 39.1066C34.6316 39.82 35.9759 40.6254 37.9091 41.7519L34.4833 43.9488C32.559 42.7882 31.2156 41.9093 30.2772 41.1127C29.3291 40.3079 28.8023 39.5936 28.5085 38.7667C28.2127 37.9341 28.1478 36.974 28.1501 35.663C28.1508 35.2195 28.1593 34.7354 28.1686 34.204Z"
          fill="#A747ED"
          stroke="#A747ED"
          strokeWidth="0.3"
          strokeMiterlimit="2.61313"
        />
        <path
          id="five"
          d="M55.4058 63.4967L51.749 65.7357C51.7115 63.7788 51.7698 62.2626 51.8166 61.0441C51.8254 60.8155 51.8337 60.5974 51.841 60.3888C51.8885 59.0261 51.8903 58.0511 51.6316 57.2323C51.3693 56.4026 50.8454 55.7482 49.8827 55.0056C48.9578 54.2922 47.6135 53.4868 45.6803 52.3604L49.1061 50.1635C51.0304 51.324 52.3738 52.2029 53.3122 52.9995C54.2603 53.8044 54.7871 54.5187 55.0809 55.3456C55.3767 56.1781 55.4416 57.1383 55.4393 58.4493C55.4386 58.8928 55.4301 59.3768 55.4208 59.9082C55.4031 60.9178 55.3824 62.0984 55.4058 63.4967Z"
          fill="#A747ED"
          stroke="#A747ED"
          strokeWidth="0.3"
          strokeMiterlimit="2.61313"
        />
        <path
          id="six"
          d="M61.9149 59.3843L58.258 61.6233C58.2205 59.6664 58.2788 58.1502 58.3256 56.9317C58.3344 56.7031 58.3428 56.4849 58.3501 56.2763C58.3975 54.9137 58.3994 53.9386 58.1406 53.1199C57.8784 52.2902 57.3544 51.6357 56.3917 50.8932C55.4668 50.1798 54.1225 49.3744 52.1893 48.248L55.6152 46.051C57.5395 47.2116 58.8828 48.0905 59.8212 48.8871C60.7693 49.6919 61.2961 50.4062 61.5899 51.2331C61.8857 52.0657 61.9507 53.0258 61.9484 54.3368C61.9476 54.7803 61.9391 55.2644 61.9298 55.7958C61.9121 56.8054 61.8914 57.986 61.9149 59.3843Z"
          fill="#A747ED"
          stroke="#A747ED"
          strokeWidth="0.3"
          strokeMiterlimit="2.61313"
        />
        <path
          id="seven"
          d="M44.4181 52.3604C42.4849 53.4868 41.1407 54.2922 40.2158 55.0056C39.253 55.7482 38.7291 56.4026 38.4669 57.2323C38.2081 58.0511 38.2099 59.0261 38.2574 60.3888C38.2647 60.5974 38.2731 60.8155 38.2818 61.0441C38.3287 62.2626 38.3869 63.7789 38.3494 65.7357L34.6926 63.4967C34.716 62.0984 34.6954 60.9178 34.6777 59.9082C34.6684 59.3768 34.6599 58.8928 34.6591 58.4493C34.6568 57.1383 34.7217 56.1781 35.0176 55.3456C35.3114 54.5187 35.8381 53.8044 36.7863 52.9995C37.7247 52.2029 39.068 51.324 40.9923 50.1635L44.4181 52.3604Z"
          fill="#A747ED"
          stroke="#A747ED"
          strokeWidth="0.3"
          strokeMiterlimit="2.61313"
        />
        <path
          id="eight"
          d="M37.9091 48.248C35.9759 49.3744 34.6316 50.1798 33.7067 50.8932C32.744 51.6357 32.2201 52.2902 31.9578 53.1199C31.6991 53.9386 31.7009 54.9137 31.7484 56.2763C31.7557 56.4849 31.764 56.7031 31.7728 56.9317C31.8196 58.1502 31.8779 59.6664 31.8404 61.6233L28.1835 59.3843C28.207 57.986 28.1863 56.8054 28.1686 55.7958C28.1593 55.2644 28.1508 54.7803 28.1501 54.3368C28.1478 53.0258 28.2127 52.0657 28.5085 51.2331C28.8023 50.4062 29.3291 49.6919 30.2772 48.8871C31.2156 48.0905 32.559 47.2116 34.4833 46.051L37.9091 48.248Z"
          fill="#A747ED"
          stroke="#A747ED"
          strokeWidth="0.3"
          strokeMiterlimit="2.61313"
        />
        <defs>
          <linearGradient
            id="paint0_linear_173_52"
            x1="45.5"
            y1="0"
            x2="45.5"
            y2="91"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F2CAF2" stopOpacity="0.5" />
            <stop offset="1" stopColor="#300351" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}
